import {MixModel, ProjectDataIndex, ProjectTab} from '../../../api/types.ts';
import CanvasComponent from '../../canvas/CanvasComponent.tsx';

interface ProjectTabCanvasProps {
    mix: MixModel;
    tab: ProjectTab;
    dataIndex: ProjectDataIndex;
    readOnly: boolean;
    reactionsEnabled: boolean;
    isFocusMode?: boolean;
    onExitFocusMode?: () => void;
}

const ProjectTabCanvas: React.FC<ProjectTabCanvasProps> = ({
    mix,
    dataIndex,
    readOnly,
    reactionsEnabled,
    isFocusMode,
    onExitFocusMode
}) => {
    return (
        <CanvasComponent
            project={mix}
            dataIndex={dataIndex}
            readOnly={readOnly}
            reactionsEnabled={reactionsEnabled}
            isFocusMode={isFocusMode}
            onExitFocusMode={onExitFocusMode}
        />
    );
};

export default ProjectTabCanvas;
